module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-loader-spinner/index.js
// module id = 2082
// module chunks = 110308036455227